import {IServerRenderedPDFTemplateInstance} from '@modules/pdf'
import {StoresInstance} from '@stores'
import {computed} from 'mobx'
import {ServerPDFTemplate} from './'

export class CatalogItemsPDFTemplate extends ServerPDFTemplate implements IServerRenderedPDFTemplateInstance {
  constructor(public stores: StoresInstance) {
    super(stores, 'catalogItems')
  }

  @computed
  override get text() {
    return 'Catalog'
  }

  override get catalogFeatures() {
    return {
      // groupBy: false,
      // viewOptions: false,
      // sortBy: false,
      // imageSources: false,
      catalogFooter: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/templates/CatalogItemsPDFTemplate.ts